<script lang="ts">
    import { IconCheck } from "@wa-icons";
</script>

<div class="absolute inset-0 flex items-center justify-center">
    <div class="inset-0 flex items-center justify-center bg-contrast/50 rounded-[6px] w-6 h-6">
        <IconCheck font-size="16" />
    </div>
</div>
